import type { TFunction } from 'i18next';

export const getStatusLabel = (status: string, t: TFunction) => {
  return {
    approved: t('labels.approved'),
    'in-review': t('labels.inReview'),
    'needs-info': t('labels.needsInfo'),
    draft: t('labels.draft'),
    submitted: t('labels.submitted'),
    denied: t('papCase.deniedLabel'),
  }[status];
};
